export class UrlUtils {
	static getSongIdFromUrl(): string | null {
		const params = new URLSearchParams(window.location.search)
		return params.get('song')
	}

	static setSongIdInUrl(songId: string): void {
		const url = new URL(window.location.href)
		url.searchParams.set('song', songId)
		window.history.pushState({}, '', url.toString())
	}

	static clearSongIdFromUrl(): void {
		const url = new URL(window.location.href)
		url.searchParams.delete('song')
		window.history.pushState({}, '', url.toString())
	}

	static listenForUrlChanges(callback: (songId: string | null) => void): () => void {
		const handlePopState = () => {
			callback(this.getSongIdFromUrl())
		}

		window.addEventListener('popstate', handlePopState)

		return () => {
			window.removeEventListener('popstate', handlePopState)
		}
	}
}
